/* import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio'; */
import React from 'react';

import styles from '../style/Checkout.module.scss';
import visaImage from '../../../../assets/image/payment/visa.png';
import masterCardImage from '../../../../assets/image/payment/mastercard.png';
// import Api from '../../../../api/Api';
import { MethodWay } from '../../../../generic/common';
/* import { StoreContext } from '../../../../store/store';
import { isEmpty } from 'underscore'; */

export default function PaymentMethod(props: {
  methodKey: string;
  methodChange: (value: MethodWay) => void;
}) {
  /*  const { user } = useContext(StoreContext);
  const [onlinePaymentLimit, setOnlinePaymentLimit] = useState<number>(0);

  useEffect(() => {
    !isEmpty(user) && getPayLimit();
  }, [user]);

  async function getPayLimit() {
    const data = await Api.price.GetOnlinePaymentLimit();
    setOnlinePaymentLimit(data);
  } 

  function onMethodRadioChange(e: RadioChangeEvent) {
    props.methodChange(e.target.value);
  }*/
  return (
    <div>
      <div className={styles.RadioPayContainer}>
        {/*         <Radio
          checked={props.methodKey === MethodWay.BC}
          value={MethodWay.BC}
          onChange={onMethodRadioChange}
        >
          Credit card
        </Radio> */}
        <div>{'Credit card'}</div>

        <div>
          <img src={visaImage} alt="visa" />
          <img src={masterCardImage} alt="masterCard" />
        </div>
      </div>
      {/*  <div className={styles.RadioPayContainer}>
        <Radio
          checked={props.methodKey === MethodWay.INV}
          value={MethodWay.INV}
          onChange={onMethodRadioChange}
        >
          Invoice (+€300)
        </Radio>
      </div>
      {props.methodKey === 'INV' && (
        <p>
          * Payment with amount {'>'} €{onlinePaymentLimit} can only be made by invoice.
        </p>
      )} */}
    </div>
  );
}
